import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import firebase from 'firebase/app';

import { getCurrentTimeStamp } from '../api/dateFormat';

export function onDigitalClassResponse(response) {
  return {
    type: types.DIGITAL_CLASS_RESPONSE,
    response
  };
}
export function timerData(response) {
  return {
    type: types.TIMER,
    response
  };
}
export function onDigitalVideoResponse(response) {
  return {
    type: types.DIGITAL_VIDEO_RESPONSE,
    response
  };
}
export function reDirectClass(response) {
  return {
    type: types.REDIRECT_CLASS,
    response
  };
}

async function onVideoAnalytics(video) {
  await firebase.analytics().logEvent('digital_class_video_event', {
    SubjectName: video.SubjectName,
    ClassTitle: video.ClassTitle,
    date_visited: new Date()
  });
}

export const digitalClassList = async (params, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = 'api/dc/student/list';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(onDigitalClassResponse(data));
    });
};

export const digitalVideoPlayer = async (
  loginData,
  uniqueCode,
  ModuleCode,
  dispatch
) => {
  const jwtToken = loginData;
  const UniqueCode = uniqueCode;
  const Modulecode = ModuleCode;
  const body = {
    UniqueCode: UniqueCode
  };
  if (ModuleCode) {
    body.ModuleCode = Modulecode;
  }

  const url = 'api/dc/student/player';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      onVideoAnalytics(data.data);
      dispatch(onDigitalVideoResponse(data));
    });
};
